import React from 'react';
import {withRouter} from "react-router-dom";
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Button, Select} from "semantic-ui-react";
import './all_work_space_style.scss';
import {MDBDataTable} from "mdbreact";
import * as tbl_headers from '../../tbl_colums';
import * as innerRoutes from "../../innerRoutes";
import CreateWorkSpace from "../../CreateWorkSpace";
import UpdateWorkSpace from "../../UpdateWorkSpace";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import cloneDeep from 'lodash/cloneDeep';

class AllWorkSpace extends React.Component{

  state = {

    create_modal: false,
    update_modal: false,

    all_branch_list: [],
    all_building_list: [],
    branch_options: [
      {
        key: 0,
        text: "All",
        value: 0,
      }
    ],
    building_options: [
      {
        key: 0,
        text: "All",
        value: 0,
      }
    ],
    floor_options: [
      {
        key: 0,
        text: "All",
        value: 0,
      }
    ],

    branch: 0,
    branch_id: 0,
    building: 0,
    building_id: 0,
    floor: 0,

    all_workspaces: [],

    update_workspace: {
      workSpaceId: 1200,
      description: "think tree",
      status: "AVAILABLE",
      closeMonTime: "20:00:00",
      closeTuesTime: "20:00:00",
      closeWedTime: "20:00:00",
      closeThursTime: "20:00:00",
      closeFriTime: "20:00:00",
      closeSatTime: null,
      closeSunTime: null,
      openMonTime: "08:00:00",
      openTuesTime: "08:00:00",
      openWedTime: "08:00:00",
      openThursTime: "08:00:00",
      openFriTime: "08:00:00",
      openSatTime: null,
      openSunTime: null,
      totalSlotCount: 50,
      userGroupList: [
        1,
        2,
        3
      ],
      branch: {
        corporateId: 1,
        branchId: 1,
        name: "Ceyentra Panadura Branch 01",
        address: "address",
        subscriptionNumber: 123
      },
      building: {
        buildingId: 1,
        code: "B001",
        location: "part 01",
        name: "Ceyentra Branch 01"
      },
      floor: {
        floorId: 1,
        description: "Ground Floor",
        level: "B001",
        status: "address",
        floorColour: 123
      },

    },

  };

  componentDidMount() {
    this.props.workspaceRemove();
    this.getBranchesByCorporateId();
    this.callAllWorkSpace();
  }

  getBranchesByCorporateId = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let branch_options = [
            {
              key: 0,
              text: "All",
              id: 0,
              value: 0,
            }
          ];
            if (response.data.branchList.length !== 0) {
              response.data.branchList.map((branch, index) => {

                const obj = {
                  key: index + 1,
                  text: branch.name,
                  id: branch.branchId,
                  value: index + 1,
                };
                branch_options.push(obj)
              })
            this.setState({
              branch_options: branch_options,
              all_branch_list: response.data.branchList
            })
          }
        } else {
          this.setState({
            branch_options: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getBranchesByCorporateId()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };


  getBuildingsByBranchId = (index) => {

    let building_options = [
      {
        key: 0,
        text: "All",
        id: 0,
        value: 0,
      }
    ];
    let buildings = null;
    if(index !== 0) {
      let branchOptions = this.state.all_branch_list;
      if(branchOptions) {
        let branchOption = branchOptions[index-1];
        buildings = branchOption.buildings;
        if(buildings) {
          buildings.map((result, index)=>{
            const obj = {
              key: index + 1,
              text: result.name,
              id: result.buildingId,
              value: index + 1,
            };
            building_options.push(obj);
          });
        }
      }
    }
    this.setState({
      building_options: building_options,
      all_building_list: buildings,
      building: 0,
      building_id: 0,
    });
  };

  getFloorsByBuildingId = (index) => {
    let floor_options = [
      {
        key: 0,
        text: "All",
        value: 0,
      }
    ];
    if(index !== 0) {
      let floorOptions = this.state.all_building_list;
      if(floorOptions) {
        let floorOption = floorOptions[index-1];
        let floors = floorOption.floors;
        if(floors) {
          floors.map((result, index)=>{
            const obj = {
              key: index + 1,
              text: result.description,
              value: result.floor_id,
            };
            floor_options.push(obj);
          });
        }
      }
    }
    this.setState({
      floor_options: floor_options,
      floor: 0
    });
  };

  onChangeBranch = (e, {value}) => {
    this.setState({
      branch: value,
      branch_id: this.state.branch_options[value].id,
      building: 0,
      building_id: 0,
      floor_options: [
        {
          key: 0,
          text: "All",
          value: 0,
        }
      ],
      floor: 0,
    });
    this.getBuildingsByBranchId(value);
  };

  onChangeBuilding = (e, {value}) => {
    this.setState({
      building: value,
      building_id: this.state.building_options[value].id,
      floor: 0
    });
    this.getFloorsByBuildingId(value);
  };

  onChangeFloor = (e, {value}) => {
    this.setState({
      floor: value
    });
  };

  callAllWorkSpace = () => {

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    let obj = {
      branchId : this.state.branch_id,
      buildingId : this.state.building_id,
      floorId : this.state.floor
    };

    this.props.spinnerHandler(true);
    axiosTags.post(apiConfig.ST_WORKSPACE_FILTER({ corporateId:corporateId }), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
            this.setState({
              all_workspaces: response.data.workSpaceList
            });
        } else {

        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.callAllWorkSpace()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  createNewWorkSpace = () => {
    this.setState({
      create_modal: true
    });
  };

  updateWorkSpace = (result) => {
    this.setState({
      update_workspace: result
    });
    this.updateWorkSpace_();
  };

  updateWorkSpace_ = () => {
    this.setState({
      update_modal: true,
    });
  };

  moveToCalender = (result) => {
    this.props.workspaceHandler(result);
    this.moveToCalender_();
  };

  moveToCalender_ = () => {
    this.props.history.push(innerRoutes.inner_route_spacetags_workspace_calender);
  };

  removeWorkSpaces = (id) => {
    swal({
      title: "Do you want to remove this workspace?",
      text: "( All upcoming reservations in this workspace will be canceled. )",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.removeWorkSpaces_(id);
            break;
          default:
        }
      });
  };

  removeWorkSpaces_ = (id) => {
    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.patch(apiConfig.ST_REMOVE_WORKSPACE({workspaceId: id,corporateId:corporateId}),null, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Workspace had removed successfully!", 0);
          this.callAllWorkSpace();
        } else {
          common.warningAlert("Oops! something was wrong, please try again!", 1);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.removeWorkSpaces(id);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  toggleCreateWorkspaceModal = () => {
    this.setState({
      create_modal: !this.state.create_modal
    });
    this.callAllWorkSpace();
  };

  toggleUpdateWorkspaceModal = () => {
    this.setState({
      update_modal: !this.state.update_modal
    });
    this.callAllWorkSpace();
  };

  render() {

    let {
      create_modal,
      update_modal,

      branch_options,
      building_options,
      floor_options,
      branch,
      building,
      floor,

      all_workspaces,
      update_workspace,

    } = this.state;

    let row = [];

    if(all_workspaces) {
      all_workspaces.map((result, index)=>{
        let obj = {
          work_space: result.description,
          branch: (result.branch!==null && result.branch!==undefined)?result.branch.name:"",
          building: (result.building!=="" && result.building!==undefined)?result.building.name:"",
          floor: (result.floor!==null && result.floor!==undefined)?result.floor.description:"",
          slot_count: result.totalSlotCount,
          reserved_slots: result.todaySlotCount,
          remain_slots: result.totalSlotCount-result.todaySlotCount,
          calender: <div>
          <SementicBtn
            circular
            icon='calendar alternate'
            onClick={() => this.moveToCalender(result)}
          />
        </div>,
          actions: <div>
          <SementicBtn
            circular
            icon='edit'
            onClick={() => this.updateWorkSpace(result)}
          />
          <SementicBtn
            className="cus-btn"
            circular
            icon='trash alternate'
            onClick={() => this.removeWorkSpaces(result.workSpaceId)}
          />
        </div>,
        };
        row.push(obj);
      });
    }

    let workspace_data = {columns: tbl_headers.ALL_WORK_SPACES, rows: row};

    let disable_building = false;
    let disable_floor = false;

    return(
      <div>

        {
          create_modal?
          <CreateWorkSpace isOpen={ true } closeModal={ this.toggleCreateWorkspaceModal } />
          :null
        }

        {
          update_modal?
            <UpdateWorkSpace isOpen={ true } data = { update_workspace } closeModal={ this.toggleUpdateWorkspaceModal } />:null
        }

        <Card>
          <CardHeader>
            All Work Space
          </CardHeader>
          <Collapse isOpen={true} id="collapseExample">
            <CardBody>
              <Row>
                <Col className={'text-right'}>
                  <Button
                    className="px-5"
                    onClick={this.createNewWorkSpace}
                  ><i aria-hidden="true" className="plus icon"></i>
                    New Workspace
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div>
                    <div>Branch</div>
                    <Select
                      placeholder='Select branch'
                      value={ branch }
                      options={ branch_options }
                      onChange={ this.onChangeBranch }
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <div>Building</div>
                    <Select
                      placeholder='Select building'
                      value={ building }
                      options={ building_options }
                      disabled={ disable_building }
                      onChange={ this.onChangeBuilding }
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <div>Floor</div>
                    <Select
                      placeholder='Select floor'
                      value={ floor }
                      options={ floor_options }
                      disabled={ disable_floor }
                      onChange={ this.onChangeFloor }
                    />
                  </div>
                </Col>
                <Col>
                  <div className={'filter-btn'}>
                    <Button
                      className="px-5"
                      onClick={ this.callAllWorkSpace }
                    >filter</Button>
                  </div>
                </Col>
              </Row>

              <MDBDataTable
                searching={true}
                displayEntries={true}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={workspace_data}
              />

            </CardBody>
          </Collapse>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    workspaceHandler: (data) => dispatch(actionCreator.workspaceSaveHandler(data)),
    workspaceRemove: () => dispatch(actionCreator.workspaceRemoveHandler()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AllWorkSpace));
